import { howItWorksSteps } from '../../../mocks/homeData';

export default function HowItWorksSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 mb-4">
              How It Works
            </h2>
            <p className="text-zinc-500 text-lg max-w-xl mx-auto">
              From integration to booking in three simple steps.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {howItWorksSteps.map((step) => (
              <div
                key={step.number}
                className="bg-zinc-50 rounded-card p-8 shadow-lifted hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600/10 rounded-xl mb-6">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${step.icon} text-xl text-blue-600`}></i>
                  </div>
                </div>
                <span className="text-xs font-semibold text-blue-600 uppercase tracking-wider">
                  Step {step.number}
                </span>
                <h3 className="text-xl font-bold text-zinc-900 mt-2 mb-3">
                  {step.title}
                </h3>
                <p className="text-zinc-500 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}